import { css } from "@emotion/css"

export const styles = {
  root: css`
    flex: 1;
    width: 100%;
    display: flex;
    margin: 0 auto;
    margin-top: var(--spacing-xxl-2);
  `,
  noDataRoot: css`
    flex: 1;
    width: 100%;
    display: flex;
    margin: 0 auto;
    margin-top: var(--spacing-m);
  `,
  overlay: css`
    opacity: 0.5;
    pointer-events: none;
  `,
  list: css`
    --rows: 1;
    --columns: 2;
    display: grid;
    grid-template-columns: repeat(var(--columns), minmax(305px, 1fr));
    grid-template-rows: repeat(var(--rows), 1fr);
    grid-column-gap: var(--spacing-xxl);
    grid-auto-flow: column;
  `,
  listLabel: css`
    margin: 0.2rem 0rem 0.1rem 0rem;
  `,
  listWrapper: css`
    margin-bottom: var(--spacing-xl);
  `,
  title: css`
    margin-bottom: 20px;
  `,
  emptyStateWidth: css`
    width: 100%;
  `,
  documents: css`
    max-height: 550px;
    overflow: hidden;
    overflow-y: auto;
  `,
}
